import { render, staticRenderFns } from "./InsuredDetails.vue?vue&type=template&id=736dc916&"
import script from "./InsuredDetails.vue?vue&type=script&lang=js&"
export * from "./InsuredDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports